import { Link } from 'react-router-dom';

export default function BenefitsSection() {
  const benefits = [
    {
      icon: 'ri-folders-line',
      title: 'Produtos Organizados em Spreadsheets',
      desc: 'Todas as categorias organizadas em planilhas fáceis de navegar. Encontre shoes, roupas e acessórios rapidamente com links verificados e atualizados.',
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Economia de Até 70%',
      desc: 'Compare preços entre fornecedores e descubra produtos virais com os melhores valores. Nossa curadoria ajuda você a economizar em cada compra internacional.',
    },
    {
      icon: 'ri-fire-line',
      title: 'Atualização Diária de Tendências',
      desc: 'Nossa equipe atualiza as planilhas todos os dias com os produtos mais recentes e tendências virais para você nunca perder uma oportunidade.',
    },
  ];

  return (
    <section className="py-14 md:py-20 px-6 md:px-10 lg:px-16 bg-background-100">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-10 md:mb-14">
          <span className="text-xs md:text-sm text-foreground-400 font-medium tracking-wide uppercase">
            Por que escolher
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-900 mt-2">
            Benefícios do HoobuySpreadsheet
          </h2>
        </div>

        {/* Benefits Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {benefits.map((b) => (
            <div
              key={b.title}
              className="bg-background-50 rounded-xl p-6 md:p-8 border border-background-200 text-center"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-5 rounded-2xl bg-primary-100 flex items-center justify-center">
                <i className={`${b.icon} text-2xl md:text-3xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 mb-3">
                {b.title}
              </h3>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed">
                {b.desc}
              </p>
            </div>
          ))}
        </div>

        {/* What is HoobuySpreadsheet */}
        <div className="mt-14 md:mt-20 grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
          {/* Left: Text */}
          <div>
            <span className="text-xs md:text-sm text-foreground-400 font-medium tracking-wide uppercase">
              O que é
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-900 mt-2 mb-2 leading-tight">
              O que é o{' '}
              <span className="text-primary-600">HoobuySpreadsheet</span>?
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mt-4">
              O <strong className="text-foreground-900">HoobuySpreadsheet</strong> é um sistema
              organizado de links e produtos do Hoobuy que permite encontrar rapidamente roupas,
              sneakers e produtos virais sem perder tempo em buscas manuais. Nossa plataforma
              reúne as melhores <strong className="text-foreground-900">planilhas hoobuy</strong> em
              um só lugar, com categorização inteligente e verificações diárias de disponibilidade.
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mt-3">
              Seja você um comprador iniciante ou experiente, o{' '}
              <strong className="text-foreground-900">best hoobuy spreadsheet 2026</strong> vai
              transformar sua experiência de compras internacionais, oferecendo economia, praticidade
              e segurança em cada link.
            </p>
            <div className="flex items-center gap-6 mt-6">
              <div>
                <span className="block font-heading text-3xl md:text-4xl font-bold text-accent-500">
                  -70%
                </span>
                <span className="text-xs text-foreground-400">Economia média</span>
              </div>
              <div>
                <span className="block font-heading text-3xl md:text-4xl font-bold text-primary-500">
                  Diária
                </span>
                <span className="text-xs text-foreground-400">Atualização</span>
              </div>
            </div>
            <Link
              to="/artigo/guia-de-compras-hoobuy-2026"
              className="inline-flex items-center gap-2 mt-6 text-sm font-medium text-primary-600 hover:text-primary-700 underline underline-offset-4 cursor-pointer"
            >
              Ler guia de compras
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          {/* Right: Images */}
          <div className="relative">
            <div className="relative z-10 rounded-2xl overflow-hidden border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20curation%20photography%20showing%20fashion%20items%20neatly%20organized%20on%20a%20warm%20cream%20linen%20surface%20with%20soft%20natural%20daylight%20from%20large%20window%20creating%20gentle%20cross%20shadows%20clean%20editorial%20european%20aesthetic%20with%20muted%20terra%20cotta%20accents%20and%20organic%20textures%20calm%20productive%20atmosphere%20curated%20collection%20style&width=700&height=900&seq=about-hoobuy-v2-01&orientation=portrait"
                alt="HoobuySpreadsheet products organized"
                className="w-full h-auto object-cover"
              />
            </div>
            <div className="absolute -top-4 -right-4 w-32 h-32 md:w-40 md:h-40 rounded-2xl overflow-hidden border-2 border-background-50 shadow-sm z-20">
              <img
                src="https://readdy.ai/api/search-image?query=Close%20up%20minimalist%20product%20detail%20macro%20photography%20of%20woven%20fabric%20textures%20and%20subtle%20brand%20labels%20on%20warm%20neutral%20linen%20background%20with%20extremely%20soft%20natural%20lighting%20and%20delicate%20micro%20shadows%20clean%20editorial%20aesthetic%20muted%20earthy%20undertones%20organic%20tactile%20composition&width=400&height=400&seq=about-hoobuy-v2-02&orientation=squarish"
                alt="HoobuySpreadsheet detail"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}